<template>
    <div class="font-prompt">
        <b-modal :id="modalId"
                 modal-class="modal-delete-account"
                 centered
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc>
            <div class="modal-base font-prompt">
                <div class="modal-base-body">
                    <div class="img-delete-account">
                        <img src="@/assets/img/img_chanel_del.png" class="w-100"/>
                    </div>
                    <div class="modal-msg">คุณได้ยกเลิกการลงทะเบียนเรียบร้อยแล้ว</div>
                    <div class="wrap-btn-close">
                        <button class="btn-white" @click="hideModal()">ปิด</button>
                    </div>
                </div><!-- modal-base-body -->
            </div><!-- modal-base -->
        </b-modal>
    </div>
</template>
<script>
/**
 * @property {Vue} busModal
 *
 * @method showModal
 * @method hideModal
 */

import { TrackingService } from "@/helper/TrackingHelper.js";

export default {
    name: "ModalDeleteAccount",
    props: {
        busModal: Object,
    },
    data: function() {
        return {
            modalId: 'modal-delete-account',
            tracking: new TrackingService(this),
        };
    },
    mounted: function() {
        this.busModal.$on('showModal', this.showModal);
        this.busModal.$on('hideModal', this.hideModal);
    },
    methods: {
        showModal: function() {
            this.$bvModal.show(this.modalId);
        },
        hideModal: function() {
            this.tracking.event("Unregis_flow", "click_close_unregis_page");
            window.location.href = "/landing/line";
            //this.$router.push('/landing/line');
            // this.$emit('hideModal');
            // this.$bvModal.hide(this.modalId);
            // window.lineFunction.closewindow();
            // window.JsFunction.closewindow();
        },
    },
}
</script>
<style lang="scss">
    @import "@/style/base/component/modal/ModalFullScreen.scss";

    .modal-delete-account {
        @extend %modal-base;

        .modal-dialog {
            height: 100%;
            .modal-content .modal-body .modal-base {
                height: 250px;

                .modal-base-body {
                    
                    background-color: #000000;
                    color: white;
                    height: 250px;
                }
            }
        }
        .img-delete-account {
            max-width: 120px;
            margin: auto;
            margin-top: 25vh;
        }
        .modal-msg {
            text-align: center;
            padding: 20px;
            font-size: 1.1rem;
        }
        .wrap-btn-close {
            max-width: 150px;
            margin: auto;
        }
    }
</style>
